import ReactPixel from 'react-facebook-pixel';

const agencyCreated = () => ReactPixel.track("CompleteRegistration", {});

const metaEvents = {
    eventAgencyCreated: agencyCreated
}

export { metaEvents }
